import { CategoryChips } from "./CategoryChips";
import { ResultCount } from "./ResultCount";
import { SortSelect } from "./SortSelect";
import type { SortValue } from "../shop.catalog";

export interface ShopFiltersProps {
  categories: readonly string[];
  selectedCategory: string | null;
  onSelectCategory: (category: string | null) => void;
  sort: SortValue;
  onSortChange: (sort: SortValue) => void;
  /** Cuántos productos quedan tras el filtro. */
  count: number;
}

/**
 * La barra de filtros: categorías a la izquierda, orden y conteo a la
 * derecha.
 *
 * En teléfono se apila (`flex-col`) en vez de encogerse: con los dos
 * grupos en la misma línea, la fila de chips se queda sin ancho y el
 * control de orden se parte. Apilado, cada uno usa el ancho entero.
 */
export function ShopFilters({
  categories,
  selectedCategory,
  onSelectCategory,
  sort,
  onSortChange,
  count,
}: ShopFiltersProps) {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <CategoryChips
        categories={categories}
        selected={selectedCategory}
        onSelect={onSelectCategory}
      />

      <div className="flex items-center justify-between gap-4 lg:justify-end">
        <ResultCount count={count} />
        <SortSelect value={sort} onChange={onSortChange} />
      </div>
    </div>
  );
}
